import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">FogTeams Privacy Policy</h1>
      <h1 className=" mb-4">Last Updated: April 2026</h1>

      <p className="mb-4">
        Welcome to FogTeams. We appreciate your interest in our products,
        services, and platforms (collectively referred to as the “Services”).
        This Privacy Policy is designed to help you understand what information
        we collect, why we collect it, and how you can manage, update, and
        delete your data. If you have any questions about this Privacy Policy,
        you can contact us at the details provided below.
      </p>
      <p className="mb-4">
        We strictly adhere to the principles of data privacy and security,
        ensuring that client data is handled in compliance with applicable legal
        frameworks, including but not limited to the Indian Information
        Technology (IT) Act, 2000, India Digital Personal Data Protection Act
        2023 (DPDPA) and the General Data Protection Regulation (GDPR). Our
        practices are aligned with industry best standards to safeguard client
        data from unauthorized access, disclosure, or misuse.
      </p>
      <p className="mb-4">
        We will request your consent before using your information for purposes
        not covered in this Privacy Policy. If you decline to provide certain
        information, FogTeams may not be able to deliver some features or
        functionality of our Services.
      </p>

      <h2 className="text-2xl font-semibold mb-3">Our Commitment to Privacy</h2>
      <p className="mb-4">
        The privacy and security of our enterprise clients, whether you are an
        active partner, a user within a client organisation, or simply a visitor
        to our site, is a priority at FogTeams. We are fully committed to your
        right to privacy and the protection of your personal and
        business-related information.
      </p>

      <h2 className="text-2xl font-semibold mb-3">
        Information FogTeams Collects
      </h2>
      <p className="mb-4">
        FogTeams collects and processes data to improve and deliver better
        services to our clients. When you interact with our Services, we may
        collect the following:
      </p>
      <h3 className="text-xl font-semibold mb-2">For our website users:</h3>
      <ul className="list-disc list-inside mb-4">
        <li>
          Information You Provide: When creating an account, using our services,
          or collaborating on business activities, you may provide personal and
          business information. This includes names, email addresses, job
          titles, business details, and other personal identifiers necessary to
          conduct our Services.
        </li>
        <li>
          Automatically Collected Data: We collect data about your interaction
          with our Services, browser types, access logs, and device-specific
          information to enhance your experience. Cookies and web beacons may
          also be used to gather information on how you use our services, but
          you can control cookie settings directly through your browser.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mb-2">
        For our enterprise clients:
      </h3>
      <ul className="list-disc list-inside mb-4">
        <li>
          For our enterprise clients, the data shared with us is stored only for
          the time and purpose of the requirements in the corresponding
          contracts with them and statutory compliances. The data is deleted
          immediately after the requirements are completed and is not stored
          anywhere in any other form.
        </li>
      </ul>
      {/* Why We Collect Information */}
      <h2 className="text-2xl font-semibold mb-3">
        Why We Collect Information
      </h2>
      <p className="mb-4">The data we collect is used for several reasons:</p>
      <h3 className="text-xl font-semibold mb-2">
        Data of our website visitors:
      </h3>
      <ul className="list-disc list-inside mb-4">
        <li>
          Delivering Our Services: We process your information to operate,
          manage, and provide our Services. For example, using your IP address
          or identifiers, we ensure the right teams or personnel can access the
          correct features and resources on our platform.
        </li>
        <li>
          Improving Performance: We analyze data to understand how users
          interact with our Services and improve both the user experience and
          technical functionality. For example, usage data helps us optimize
          product workflows and resolve technical issues more efficiently.
        </li>
        <li>
          Developing New Features: Your data helps us innovate and create new
          tools and features tailored to business needs.
        </li>
        <li>
          Personalized Services: We use your data to provide customized
          experiences, like user interface personalization, recommended
          features, or region-specific offerings.
        </li>
        <li>
          Enterprise Communication: FogTeams may use the contact information
          provided to communicate with you directly, including sharing updates
          on new features, security notifications, or responding to your
          inquiries.
        </li>
      </ul>
      <h3 className="text-xl font-semibold mb-2">
        Data shared by our enterprise clients:
      </h3>
      <ul className="list-disc list-inside mb-4">
        <li>
          Data shared by our enterprise clients is used exclusively for the
          purpose of rendering them the products and services as enshrined in
          the agreement we have with them.
        </li>
      </ul>

      {/* Information Sharing */}
      <h2 className="text-2xl font-semibold mb-3">Information Sharing</h2>
      <p className="mb-4">
        We do not sell your personal information. However, FogTeams may share
        data with third parties in the following contexts:
      </p>
      <h3 className="text-xl font-semibold mb-2">For our website users:</h3>
      <ul className="list-disc list-inside mb-4">
        <li>
          Service Providers: We work with trusted third-party partners who
          process data on our behalf, such as cloud infrastructure providers,
          marketing services, or technical support teams. These partners are
          contractually obligated to comply with our privacy policies and ensure
          the confidentiality of your information.
        </li>
        <li>
          Compliance with Legal Requirements: We may share information if we are
          required to do so by law, or to enforce our Terms of Service, prevent
          fraud, or protect the security of our systems.
        </li>
      </ul>
      <h3 className="text-xl font-semibold mb-2">
        Data shared by our enterprise clients:
      </h3>
      <ul className="list-disc list-inside mb-4">
        <li>
          Under no circumstances will client data be used for any other
          purposes, nor will it be shared with third parties, unless explicitly
          required by law or agreed upon in writing with the client.
        </li>
      </ul>

      {/* Data Management and Deletion */}
      <h2 className="text-2xl font-semibold mb-3">
        Data Management and Deletion
      </h2>
      <p className="mb-4">
        For website users, at any time, you may request a copy of your data or
        opt to delete your account entirely by sending an email to
        info@fogteams.com. Please note that deleting your account will result in
        the loss of access to our Services and features tied to your business
        information.
      </p>
      <p className="mb-4">
        For enterprise clients, you can request a copy of your data or opt to
        delete your data entirely as per the terms of your contract with us by
        sending an email to tanmay.hiremath@fogteams.com
      </p>

      {/* Data Retention */}
      <h2 className="text-2xl font-semibold mb-3">Data Retention</h2>
      <p className="mb-4">
        We retain data as long as necessary for the purposes outlined in this
        Privacy Policy or as required to fulfill legal, security, or operational
        obligations. This may include:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Financial record-keeping for auditing purposes</li>
        <li>Compliance with regulatory requirements</li>
        <li>
          Retaining information necessary for the continuity of our business
          relationships
        </li>
      </ul>
      <p className="mb-4">
        For enterprise clients, the data is only retained for the purpose of
        fulfilling our legal and contractual obligations with the client and
        retained only till it is needed. It is deleted immediately after the
        purpose is fulfilled.
      </p>

      {/* Security */}
      <h2 className="text-2xl font-semibold mb-3">Security</h2>
      <p className="mb-4">
        At our site you can be assured that your Personal data is secure and
        consistent with current industry standards. The importance of security
        for all Personal data associated with our user is of utmost concern to
        us. We do not do any transmission of the Personal data collected through
        our website. Our company has a requisite information security policy in
        place with appropriate managerial, technical, operational and physical
        security control measures to protect the personal and non-personal
        information that is collected from website users.
      </p>
      <p className="mb-4">
        Unfortunately, no data transmission over the Internet or any wireless
        network can be guaranteed to be 100% secure. As a result, while we
        strive to protect your Personal data, you acknowledge that:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>
          there are security and privacy limitations of the Internet which are
          beyond our control;
        </li>
        <li>
          the security, integrity and privacy of any and all information and
          data exchanged between you and us through this site cannot be
          guaranteed; and
        </li>
        <li>
          any such information and data may be viewed or tampered with in
          transit by a third party.
        </li>
      </ul>

      {/* Data Subject Rights */}
      <h2 className="text-2xl font-semibold mb-3">Data Subject Rights</h2>
      <p className="mb-4">
        Individuals have several rights regarding the handling of their personal
        data. These rights are designed to give you more control over how your
        information is used and processed.
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>
          Right to Access (Subject Access Request - SAR): You have the right to
          request copies of your personal data in writing. While we aim to
          provide all requested information, certain limitations, exemptions,
          and the rights of others may restrict what we can share. Requests
          should clearly indicate that a SAR is being made, and we may ask for
          proof of identity or, where legally permitted, a processing fee.
        </li>
        <li>
          Right to Rectification: If any personal data we hold about you is
          inaccurate or incomplete, you can request that we correct or update
          it. We will act promptly to ensure your information is accurate.
        </li>
        <li>
          Right to Withdraw Consent: You may withdraw your consent at any time
          for the processing of personal data that we handle based on your
          previous consent. Please note that withdrawing consent does not affect
          the legality of any processing carried out before your withdrawal.
        </li>
        <li>
          Right to Object to Processing (including Automated Processing and
          Profiling): We dont process your data until it is required for
          providing you the services, but you can object to processing of your
          data, and we will honor valid requests unless we have compelling
          legitimate grounds or another lawful reason to continue processing. We
          will always comply with requests to opt out of marketing
          communications.
        </li>
        <li>
          Right to Erasure ("Right to be Forgotten"): You may request that we
          erase your personal data. We will fulfill such requests unless we have
          a valid legal reason to retain the data, such as compliance with
          business record-keeping requirements or other lawful obligations.
        </li>
        <li>
          Right to Restrict Processing: Under certain circumstances, you may
          request that we restrict the processing of your personal data. We will
          comply with such requests unless we are legally obligated to continue
          processing your data for specific purposes.
        </li>
        <li>
          Right to Data Portability: In certain situations, you have the right
          to request a copy of your personal data in a structured,
          machine-readable format, and for it to be transferred to another
          service provider. Although we believe this right may not apply to our
          Services, we will comply with valid requests as required. Please note
          that transferring data to another provider does not automatically
          result in the deletion of your personal data from our systems.
        </li>
        <li>
          Right to Lodge a Complaint with the Supervisory Authority: If you have
          concerns about how we handle your personal data, we encourage you to
          contact us directly to resolve the issue. However, you also have the
          right to raise your concerns with the relevant supervisory authority.
        </li>
      </ul>

      {/* Changes to This Privacy Policy */}
      <h2 className="text-2xl font-semibold mb-3">
        Changes to This Privacy Policy
      </h2>
      <p className="mb-4">
        FogTeams may update this policy as necessary to reflect changes in
        legal, technical, or business developments. You will be notified of
        significant updates, and the revised policy will take effect upon
        notification. Continued use of our Services after an update indicates
        your agreement with the revised terms.
      </p>

      {/* Grievance Redressal */}
      <h2 className="text-2xl font-semibold mb-3">Grievance Redressal</h2>
      <p className="mb-4">
        If you have any grievance or complaint related to the processing of your
        personal information, we at FogTeams are committed to addressing it
        promptly and effectively. The contact information for the Grievance
        Officer, Tanmay Hiremath, Data Privacy Officer, email address:{" "}
        <a
          href="mailto:tanmay.hiremath@fogteams.com"
          className="text-blue-600 hover:text-blue-800">
          tanmay.hiremath@fogteams.com
        </a>
      </p>
      <p className="mb-4">
        If you have any concerns or questions about how your personal
        information is being handled, feel free to reach out to us at the
        provided email address. Your feedback is essential in helping us
        maintain our commitment to data protection and privacy.
      </p>
      <p className="mb-4">
        Data Protection Officer <br />
        Name - Tanmay Hiremath <br />
        Email ID - tanmay.hiremath@fogteams.com <br />
        Contact Number - 7045335990
      </p>
      <p className="mb-4">
        Company Legal Name: Fogteams Tech Private Limited <br />
      </p>
    </div>
  );
};

export default PrivacyPolicy;
